<template>
  <div class="refund">
    <div class="refund_nav">
      <navbar
        title="申请退还"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row class="phone_info">
        <van-col span="24" class="num">
          退还手机数量<span>共1台</span>
        </van-col>
        <van-col span="24" class="price">
          申退金额<span class="money">￥<span>2000.00</span></span>
        </van-col>
      </van-row>
      <van-row class="show_address_refund">
        <van-col span="24" class="title">退还地址信息</van-col>
        <van-col span="24" class="show_address">
          <span class="address">
            <img src="../../../assets/accountAgent/common/address.png" alt="" />
          </span>
          <p class="name">
            {{ addressInfo.realname }}<span>{{ addressInfo.mobile }}</span>
          </p>
          <p class="site">
            {{ addressInfo.address_name + addressInfo.detail_address }}
          </p>
        </van-col>
      </van-row>
      <van-row class="refund_info">
        <van-col span="24" class="item">
          <span class="label">退款账户</span>
          <span class="val">退回余额</span>
        </van-col>
        <van-col span="24" class="item" @click="showExpress">
          <span class="label">物流公司（选填）</span>
          <span class="_select" v-if="!expressValue">请选择物流公司</span>
          <span class="_select val" v-else>{{ expressValue }}</span>
          <van-icon name="arrow" />
        </van-col>
        <van-col span="24" class="item _express">
          <van-field
            v-model="express"
            label="物流编号（选填）"
            placeholder="请填写物流编号"
            input-align="right"
          />
        </van-col>
        <van-col span="24" class="item last">
          <span class="label">退还原因</span>
        </van-col>
        <van-col span="24" class="item _last">
          <van-field
            v-model="reason"
            rows="4"
            autosize
            type="textarea"
            placeholder="补充详细信息以便更快处理（选填）"
          />
        </van-col>
      </van-row>
    </div>
    <van-row class="refund_footer">
      <van-col span="24">
        <span class="total">退还金额：<span>￥2000.00</span></span>
        <span class="button">
          <btn
            :btntext="'提交'"
            :btnwidth="'10.4rem'"
            :height="'3.6rem'"
            :bgcolor="'#F9591B'"
            :borderradius="'1.8rem'"
            :btncolor="'#fff'"
            :fontsize="'1.8rem'"
            :fontweight="700"
            @btnClick="submit"
          />
        </span>
      </van-col>
    </van-row>

    <van-popup v-model="showPicker" position="bottom">
      <van-row>
        <van-col class="title" span="24">
          <span class="cancel" @click="onCancel">取消</span>
          选择物流公司
          <span class="confirm" @click="onConfirm">确定</span>
        </van-col>
        <van-col class="list" span="24">
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="list.length != 0"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                class="item"
                v-for="(item, index) in list"
                :key="index"
                @click="change(item)"
              >
                <span>{{ item.name }}</span>
                <img
                  v-if="selectItem.id === item.id"
                  src="../../../assets/accountAgent/order/selected.png"
                />
                <img
                  v-else
                  src="../../../assets/accountAgent/order/no_select.png"
                />
              </div>
            </van-list>
          </van-pull-refresh>
        </van-col>
      </van-row>
    </van-popup>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      express: "",
      reason: "",
      expressValue: "",
      showPicker: false,
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      selectItem: {},
      addressInfo: {},
    };
  },
  created() {
    this.getExpress();
    this.getAddress();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    submit() {
      this.$api
        .post("/investment/member/agent/order/after/add", {
          ordersn: this.$route.query.ordersn,
          return_post_name: this.selectItem.name,
          return_post_code: this.selectItem.code,
          return_post_no: this.express,
          reason: this.reason,
        })
        .then((res) => {
          this.$router.push({
            path: "/accountAgent/result",
            query: {
              type: 3,
              ordersn: this.$route.query.ordersn,
            },
          });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    // getAddress() {
    //   this.$router.push({
    //     path: "/accountAgent/address",
    //     query: {
    //       type: 2,
    //     },
    //   });
    // },
    showExpress() {
      this.showPicker = true;
    },
    getAddress() {
      this.$api.post("/investment/member/agent/config/detail").then((res) => {
        this.addressInfo = res;
      });
    },
    change(item) {
      this.selectItem = item;
    },
    onConfirm() {
      if (this.selectItem.id) {
        this.expressValue = this.selectItem.name;
        this.showPicker = false;
      } else {
        this.$toast("请选择收货地址");
      }
    },
    onCancel() {
      this.selectItem = {};
      this.expressValue = "";
      this.showPicker = false;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getExpress();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getExpress();
      //    setTimeout(() => {
      //      this.$toast('刷新成功');
      //      this.isLoading = false;
      //    }, 500);
    },
    getExpress() {
      this.$api
        .post("/platformsys/member/express/logistics/list", {
          page: this.page,
          size: 50,
          // name: "",
        })
        .then((res) => {
          this.allList = res.total;
          //		        if(this.page = 1) {
          //		        	this.list = [];
          //		        }
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
            this.timeout = true;
          } else {
            this.$toast(message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.refund {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .refund_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 6.5rem;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .phone_info {
      height: 8.3rem;
      border-radius: 0.6rem;
      background: #fff;
      padding: 1.2rem;
      color: #333;
      font-size: 1.4rem;
      box-sizing: border-box;
      margin-bottom: 1rem;

      .num {
        height: 2.4rem;
        line-height: 2.4rem;

        span {
          float: right;
        }
      }

      .price {
        color: #999;
        height: 2.3rem;
        line-height: 2.3rem;
        margin-top: 1.1rem;

        .money {
          color: #f9591b;
          float: right;
          font-size: 1.3rem;

          span {
            font-size: 1.8rem;
          }
        }
      }

      .pay {
        color: #333;
        text-align: right;
        margin-top: 1.2rem;

        .money {
          font-size: 1.3rem;
          font-weight: 700;
          margin-left: 0.2rem;

          .num {
            font-size: 2.2rem;

            span {
              font-size: 1.6rem;
            }
          }
        }
      }
    }

    .show_address_refund {
      min-height: 11.5rem;
      background: #fff;
      border-radius: 0.6rem;
      margin-bottom: 1rem;
      padding-top: 1.2rem;
      box-sizing: border-box;

      .title {
        color: #333;
        font-size: 1.4rem;
        height: 2.4rem;
        line-height: 2.4rem;
        padding: 0 1.2rem;
      }
      .show_address {
        min-height: 7.9rem;
        margin-bottom: 0;
        padding: 1.2rem 1rem 1.2rem 5.1rem;
        background: #fff;
        border-radius: 0.6rem;
        text-align: left;
        position: relative;
        box-sizing: border-box;

        .address {
          width: 5.1rem;
          padding-left: 1rem;
          min-height: 8.5rem;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          display: flex;
          align-items: center;
          box-sizing: border-box;

          img {
            width: 2.6rem;
          }
        }

        .name {
          color: #333;
          font-size: 1.6rem;
          font-weight: 700;
          height: 2.6rem;
          line-height: 2.6rem;
          margin-bottom: 0.6rem;

          span {
            margin-left: 3rem;
          }
        }

        .site {
          color: #999;
          font-size: 1.4rem;
          line-height: 2.3rem;
        }
      }
    }

    .refund_info {
      min-height: 31.2rem;
      border-radius: 0.6rem;
      background: #fff;
      padding: 1.5rem 1.2rem;
      color: #333;
      font-size: 1.4rem;
      box-sizing: border-box;

      .item {
        line-height: 2rem;
        margin-bottom: 1.6rem;

        span {
          display: inline-block;
          width: calc(100% - 12.3rem);
          text-align: right;
        }

        ._select {
          width: calc(100% - 14.5rem);
          color: #c0c0c0;
        }

        .label {
          color: #666;
          width: 12.3rem;
          text-align: left;
          min-height: 2rem;
          height: 100%;
          float: left;
        }

        .van-icon {
          float: right;
          color: #c0c0c0;
          width: 1.6rem;
          margin-top: 0.2rem;
        }

        .val {
          color: #333;
        }
      }

      ._express {
        .van-cell {
          padding: 0;

          /deep/.van-field__label {
            width: 12.3rem !important;
            margin-right: 0;
          }

          /deep/.van-cell__value {
            padding-right: 1.6rem;
            font-size: 1.4rem;
          }
        }
      }

      .last {
        margin-bottom: 1.2rem;
      }

      ._last {
        margin: 0;

        .van-cell {
          background: #f5f6f7;
          padding: 1.2rem;
          color: #333;
          border-radius: 0.2rem;

          .van-field__control {
            color: #333;
            font-size: 1.3rem;
          }
        }
      }
    }
  }

  .refund_footer {
    height: 5rem;
    padding: 0.7rem 1.2rem 0;
    background: #fff;
    color: #f9591b;
    text-align: right;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    .total {
      line-height: 3.6rem;
      font-size: 1.4rem;
      span {
        font-size: 1.8rem;
        font-weight: 700;
        margin-right: 1.2rem;
      }
    }
    .button {
      float: right;
    }
  }

  /deep/.van-popup {
    height: 316px;
    .van-row {
      height: 100%;
      .title {
        color: #333;
        text-align: center;
        background: #f5f6f7;
        height: 52px;
        line-height: 52px;
        font-size: 16px;
        padding: 0 12px;

        .cancel {
          color: #666;
          float: left;
        }

        .confirm {
          color: #f9591b;
          float: right;
        }
      }
      .list {
        height: calc(100% - 52px);

        .van-pull-refresh {
          height: 100%;
          box-sizing: border-box;
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;

          .van-list__finished-text {
            display: none;
          }

          .item {
            color: #333;
            font-size: 14px;
            padding: 0 11px;
            height: 46px;
            line-height: 46px;
            img {
              width: 14px;
              float: right;
              margin-top: 16px;
            }
          }
        }
      }
    }
  }
}
</style>